import { IonContent, IonPage } from "@ionic/react";
import { HTMLAttributes, PropsWithChildren } from "react";
import { Link } from "react-router-dom";

import { Footer } from "@/components/layouts/Footer";

import ss4kidslogo from "@/assets/ss4kids-logo-2-lines.png";

type UnauthenticatedPageLayoutProps = HTMLAttributes<HTMLDivElement> & {
  title?: string;
};

export const UnauthenticatedPageLayout = ({
  title,
  className,
  children,
}: PropsWithChildren<UnauthenticatedPageLayoutProps>) => {
  return (
    <IonPage>
      <IonContent fullscreen className="bg-white">
        <div className="max-w-screen-lg mx-auto flex flex-col gap-4 p-4 bg-white">
          <div className="flex items-center justify-center py-4">
            <Link to="/">
              <img src={ss4kidslogo} className="h-[90px] w-[245px]" />
            </Link>
          </div>

          {title && <h1 className="text-4xl text-center">{title}</h1>}

          <div className={className}>{children}</div>

          <Footer />
        </div>
      </IonContent>
    </IonPage>
  );
};
